import React, { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import Loading from './components/Loading';
import ProtectedRoute from './components/ProtectedRoute';
import ConfirmToast from './components/modals/ConfirmToast';
import { useAuth } from './contexts/AuthContext';
import NavigationBar from './components/NavigationBar';

const LoginPage = lazy(() =>
  /* webpackChunkName: "LoginPage" */ import('./pages/LoginPage')
);
const RuleGroupsPage = lazy(() =>
  /* webpackChunkName: "RuleGroupsPage" */ import('./pages/RuleGroupsPage')
);
const UsersPage = lazy(() =>
  /* webpackChunkName: "UsersPage" */ import('./pages/UsersPage')
);
const AdminOrganizationsPage = lazy(() =>
  /* webpackChunkName: "AdminOrganizationsPage" */ import(
    './pages/AdminOrganizationsPage'
  )
);
const AdminUsersPage = lazy(() =>
  /* webpackChunkName: "AdminUsersPage" */ import('./pages/AdminUsersPage')
);
const RuleGroupPage = lazy(() =>
  /* webpackChunkName: "RuleGroupPage" */ import('./pages/RuleGroupPage')
);
const ResetPasswordPage = lazy(() =>
  /* webpackChunkName: "ResetPasswordPage" */ import('./pages/ResetPasswordPage')
);
const HomePage = lazy(() =>
  /* webpackChunkName: "HomePage" */ import('./pages/HomePage')
);

const ActivatePage = lazy(() =>
  /* webpackChunkName: "ActivatePage" */ import('./pages/ActivatePage')
);

export default function App() {
  const auth = useAuth();

  return (
    <>
      <ConfirmToast />
      <NavigationBar />
      <Suspense fallback={<Loading />}>
        <Routes key={auth.selectedOrganization?.id || 'none'}>
          <Route path='/login' element={<LoginPage />} />
          <Route
            exact
            path='/user/reset-password/:token1/:token2/:token3'
            element={<ResetPasswordPage />}
          />
          <Route
            path='/user/activate/:token1/:token2/:token3'
            element={<ActivatePage />}
          />
          <Route element={<ProtectedRoute />}>
            <Route path='/' element={<HomePage />} />
          </Route>
          <Route element={<ProtectedRoute roles={['rule.admin']} />}>
            <Route path='/rulegroups' element={<RuleGroupsPage />} />
            <Route path='/rulegroups/:id' element={<RuleGroupPage />} />
          </Route>
          <Route element={<ProtectedRoute roles={['user.admin']} />}>
            <Route path='/users' element={<UsersPage />} />
          </Route>

          <Route element={<ProtectedRoute roles={['root']} />}>
            <Route
              path='/admin/organisations'
              element={<AdminOrganizationsPage />}
            />
            <Route path='/admin/users' element={<AdminUsersPage />} />
          </Route>
        </Routes>
      </Suspense>
    </>
  );
}
